import { BIRD_EYE_DEBUG_ON, BirdsEyeLocation } from './birds-view.service';
import { getBearingFromCompass } from '../helpers/bearings-convertor';

export interface LocationHistoryMockModel {
  lat: number;
  lng: number;
  bearing: string;
  speed: number;
  [key: string]: any;
}

// Importing math utilities
const EARTH_RADIUS = 6371000; // Earth radius in meters

function toRadians(degrees: number): number {
  return degrees * (Math.PI / 180);
}

function toDegrees(radians: number): number {
  return radians * (180 / Math.PI);
}

export function calculateNextPoint(
  latitude: number,
  longitude: number,
  bearing: string | number,
  speed: number,
  time: number,
  randomizeSpeed = false,
  randomizeBearing = false,
): BirdsEyeLocation {
  // Distance traveled in meters
  if (randomizeSpeed) {
    speed = speed / 2 + Math.random() * speed; // RANDOM SPEED
    // speed = speed/4 + Math.random()*(speed + speed/4); // RANDOM SPEED
  }
  const distance = speed * time;
  if (BIRD_EYE_DEBUG_ON) {
    // console.debug(`[BV MOCK Stats]: Speed: ${(speed * 3600 / 1609.34).toFixed(0)} mi/h  |  Dist: ${(distance).toFixed(0)} m  |  Time: ${time}s`);
    console.debug(
      `[BV MOCK Stats]: Speed: ${((speed * 3600) / 1000).toFixed(0)} km/h  |  Dist: ${distance.toFixed(0)}m  |  Time: ${time}s`,
    );
  }

  // Convert latitude, longitude, and bearing to radians
  const lat1 = toRadians(latitude);
  const lon1 = toRadians(longitude);
  let bearingMapped = typeof bearing === 'string' ? getBearingFromCompass(bearing) : bearing;
  if (randomizeBearing) {
    bearingMapped = (bearingMapped - 20 + Math.random() * 40 + 360) % 360;
  } else {
    bearingMapped = (bearingMapped + 30) % 360;
  }
  const bearingRad = toRadians(bearingMapped);

  // Calculate the new latitude
  const lat2 = Math.asin(
    Math.sin(lat1) * Math.cos(distance / EARTH_RADIUS) +
      Math.cos(lat1) * Math.sin(distance / EARTH_RADIUS) * Math.cos(bearingRad),
  );

  // Calculate the new longitude
  const lon2 =
    lon1 +
    Math.atan2(
      Math.sin(bearingRad) * Math.sin(distance / EARTH_RADIUS) * Math.cos(lat1),
      Math.cos(distance / EARTH_RADIUS) - Math.sin(lat1) * Math.sin(lat2),
    );

  // Convert back to degrees
  return {
    latitude: parseFloat(toDegrees(lat2).toFixed(6)),
    longitude: parseFloat(toDegrees(lon2).toFixed(6)),
    bearing: bearingMapped,
  };
}
